// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"168":"17b79037e9de67e8","1116":"bedcee0e2395b90e","1513":"1bf552b44fa8553f","5214":"64e0c34bf0a01006","6521":"ac4b4ef4361ab534","8187":"7f7be6122e64f20a"}[chunkId] + ".js";
};